import React from "react";
import { Group, Arrow, Text, Tag, Label, Line } from "react-konva";
import config from "../../../utils/config";
import { useSelector } from "react-redux";
import { getMeasurementCoordinates } from "../../../lib/redux/slices/measurements-slice";
export const METRIC_GAP = 60;
export const METRIC_GAP_Half = METRIC_GAP / 2;

const Metrics = ({
  x,
  y,
  width,
  height,
  text,
  orientation,
  offsetX = 0,
  offsetY = 0,
  rotation = "",
  canvasOffsetX,
  canvasOffsetY,
  index,
  degree,
  scale = 1,
  label = ''
}) => {
  const sinkCoordinate = useSelector(getMeasurementCoordinates);

  // Group data by rotation
  const groupedData = {};
  for (const key in sinkCoordinate) {
    const element = sinkCoordinate[key];

    if (!("rotation" in element)) {
      continue;
    }

    if (!groupedData[element.rotation]) {
      groupedData[element.rotation] = [];
    }
    groupedData[element.rotation].push(element);
  }
  const maxIndex = degree in groupedData ? groupedData[degree].length : 0;

  const textRef = React.useRef();

  // const strokeColor = "#b52f40";
  const strokeColor = "#000";
  const strokeWidth = 1;
  const isVertical = orientation === "vertical";

  const arrowPoints = isVertical
    ? [METRIC_GAP / 2, 0, METRIC_GAP / 2, height]
    : [0, METRIC_GAP / 2, width, METRIC_GAP / 2];

  // const linePoints1 = isVertical
  //   ? [0, 0, METRIC_GAP, 0]
  //   : [0, 0, 0, METRIC_GAP];
  // const linePoints2 = isVertical
  //   ? [0, height, METRIC_GAP, height]
  //   : [width, 0, width, METRIC_GAP];

  const linePointPosTop =
    rotation === "top"
      ? METRIC_GAP +
        METRIC_GAP_Half * (typeof index === "undefined" ? maxIndex : index)
      : 0;

  const linePointPosLeft =
    rotation === "left"
      ? METRIC_GAP +
        METRIC_GAP_Half * (typeof index === "undefined" ? maxIndex : index)
      : 0;

  const linePointPosLR =
    rotation === "right"
      ? linePointPosLeft -
        METRIC_GAP_Half * (typeof index === "undefined" ? maxIndex : index)
      : linePointPosLeft;

  const linePointPosTB =
    rotation === "bottom"
      ? linePointPosTop -
        METRIC_GAP_Half * (typeof index === "undefined" ? maxIndex : index)
      : linePointPosTop;

  const linePoints1 = isVertical
    ? [linePointPosLR, 0, METRIC_GAP_Half, 0]
    : [0, linePointPosTB, 0, METRIC_GAP_Half];

  const linePoints2 = isVertical
    ? [linePointPosLR, height, METRIC_GAP_Half, height]
    : [width, linePointPosTB, width, METRIC_GAP_Half];

  const metricGapX = rotation === "left" ? 10 : METRIC_GAP / 2 + 10;
  const metricGapY = rotation === "top" ? 10 : METRIC_GAP / 2 + 10;

  return (
    <Group x={x} y={y} offsetX={offsetX} offsetY={offsetY}>
      <Arrow
        points={arrowPoints}
        stroke={strokeColor}
        fill={strokeColor}
        pointerAtBeginning
        strokeWidth={strokeWidth}
        pointerLength={0}
        pointerWidth={20}
        dash={[10, 5]}      
        dashEnabled={true}
      />

      {/* <Line
        points={linePoints1}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        points={linePoints2}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      /> */}

      <Label
        x={isVertical ? metricGapX : width / 2 - textRef?.current?.width() / 2}
        y={isVertical ? height / 2 + textRef?.current?.width() / 2 : metricGapY}
        rotation={isVertical ? -90 : 0}
      >
        <Text
          align="center" // Horizontal alignment
          verticalAlign="middle" // Vertical alignment
          text={`${label ? `${label}\n` : ''}${Math.round(text * config.defaultRatio)} mm`.trim()}
          ref={textRef}
          fontSize={scale > 1 ? 17 : 20 + scale}
        />
      </Label>
    </Group>
  );
};

export default Metrics;
